import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { checkIsAdmin } from '../lib/adminApi';
import { isSupabaseConfigured } from '../../lib/supabaseClient';

function AdminRoute({ children }) {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      if (!isSupabaseConfigured || authLoading) {
        return;
      }

      if (!user) {
        if (!cancelled) {
          setIsAdmin(false);
          setChecking(false);
        }
        return;
      }

      setChecking(true);
      try {
        const ok = await checkIsAdmin();
        if (!cancelled) {
          setIsAdmin(ok);
        }
      } catch {
        if (!cancelled) {
          setIsAdmin(false);
        }
      } finally {
        if (!cancelled) {
          setChecking(false);
        }
      }
    }

    verify();
    return () => {
      cancelled = true;
    };
  }, [user, authLoading]);

  if (!isSupabaseConfigured) {
    return (
      <div className="admin-login">
        <div className="admin-login-card">
          <h1>Admin unavailable</h1>
          <p>Configure Supabase in `.env.local`, then run `supabase-admin.sql`.</p>
        </div>
      </div>
    );
  }

  if (authLoading || checking) {
    return (
      <div className="admin-login">
        <div className="admin-login-card">
          <p>Checking administrator access...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return (
      <div className="admin-login">
        <div className="admin-login-card">
          <h1>Access denied</h1>
          <p>
            Your account is signed in but is not an administrator. Add your user
            to the <code>admin_users</code> table in Supabase.
          </p>
        </div>
      </div>
    );
  }

  return children;
}

export default AdminRoute;
